export const navToUrl = (url: string) => (window.location.href = url);
